export default __webpack_public_path__ + "media/d088ff7b6fa5a7134d66aa2eb7d4fff3c67cf0535eb4abd3e9b463079c52e424.svg";